export const iconFontAwesomeShoppingCashRegister = (
	<i className="fa-solid fa-cash-register"></i>
);
